import { AppSettings } from '../directus/directusClient';

export const DEFAULT_GA_MEASUREMENT_ID = 'G-GVM2XB8CV9';

export const getMeasurementId = (appSettings?: AppSettings | null): string => {
  // Priority: CMS settings > Environment variable > Default
  if (appSettings?.ga_measurement_id) {
    console.log('[Analytics] Using CMS measurement ID:', appSettings.ga_measurement_id);
    return appSettings.ga_measurement_id;
  }
  
  const envId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (envId) {
    console.log('[Analytics] Using environment variable measurement ID:', envId);
    return envId;
  }
  
  console.log('[Analytics] Using default measurement ID:', DEFAULT_GA_MEASUREMENT_ID);
  return DEFAULT_GA_MEASUREMENT_ID;
};

export const isAnalyticsEnabled = (appSettings?: AppSettings | null): boolean => {
  const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  return environment === 'production' && Boolean(getMeasurementId(appSettings));
};
